import * as THREE from 'three'
import { useRef, useState, useMemo, useEffect, Suspense } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { Billboard, Text, TrackballControls } from '@react-three/drei'

const WORDS = [
  'Nisha',
  'chuck',
  'strong',
  'good',
  'happy',
  'sad',
  'birthday',
  'life',
  'okay',
  'PAGAL',
  '😂',
  'leave',
  'jaude',
  'crew',
  'hug',
  'family',
  'scold',
  'assumption',
  'mum',
  'bhendi',
  'galley',
  'jain',
  'Michhami Dukkadam',
  '🪂',
  'pani puri',
  '🤗',
  'samosa',
  'dosa',
  'thepla',
  'utappam',
  'sandwich',
  'mad',
  'Virat Kohli',
  '✈️',
  'haha',
  'purpose',
  'stupid',
  'thanks',
  'sorry',
  'sleep',
  'garnier',
  'chennai',
  'doha',
  'mumbai',
  'qatar',
  'indigo',
  'jet',
  '😅',
  "I'm fine"
]

function EmojiSprite({ emoji, size = 3, ...props }) {
  const canvas = useMemo(() => {
    const c = document.createElement('canvas')
    const ctx = c.getContext('2d')
    c.width = 256
    c.height = 256
    ctx.font = '200px sans-serif' // system emoji font
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.fillText(emoji, 128, 128)
    return c
  }, [emoji])

  const texture = useMemo(() => new THREE.CanvasTexture(canvas), [canvas])

  return (
    <Billboard {...props}>
      <sprite scale={[size, size, 1]}>
        <spriteMaterial map={texture} transparent />
      </sprite>
    </Billboard>
  )
}

function Word({ children, ...props }) {
  const color = new THREE.Color()
  const fontProps = { font: '/Inter-Bold.woff', fontSize: 2.5, letterSpacing: -0.05, lineHeight: 1, 'material-toneMapped': false }

  const isEmoji = ['😅', '✈️', '🤗', '🪂', '😂'].includes(children)

  const ref = useRef()
  const [hovered, setHovered] = useState(false)
  const over = (e) => (e.stopPropagation(), setHovered(true))
  const out = () => setHovered(false)
  // Change the mouse cursor on hover¨
  useEffect(() => {
    if (hovered) document.body.style.cursor = 'pointer'
    return () => (document.body.style.cursor = 'auto')
  }, [hovered])

  // Only run animation for Text, not EmojiSprite
  useFrame(() => {
    if (!isEmoji && ref.current) {
      ref.current.material.color.lerp(color.set(hovered ? '#fa2720' : 'white'), 0.5)
    }
  })

  if (isEmoji) {
    return <EmojiSprite emoji={children} size={3} {...props} />
  }
  return (
    <Billboard {...props}>
      <Text ref={ref} onPointerOver={over} onPointerOut={out} onClick={() => console.log('clicked')} {...fontProps} children={children} />
    </Billboard>
  )
}

function Cloud({ count = 4, radius = 20 }) {
  // Create a count x count random words with spherical distribution
  const words = useMemo(() => {
    const temp = []
    const spherical = new THREE.Spherical()
    const phiSpan = Math.PI / (count + 1)
    const thetaSpan = (Math.PI * 2) / count
    let word_count = 0
    for (let i = 1; i < count + 1; i++)
      for (let j = 0; j < count; j++) {
        temp.push([new THREE.Vector3().setFromSpherical(spherical.set(radius, phiSpan * i, thetaSpan * j)), WORDS[word_count]])
        // console.log(WORDS[word_count], word_count)
        word_count = word_count + 1
      }
    return temp
  }, [count, radius])
  return words.map(([pos, word], index) => <Word key={index} position={pos} children={word} />)
}

export default function App() {
  return (
    <Canvas dpr={[1, 2]} camera={{ position: [0, 0, 35], fov: 90 }}>
      <fog attach="fog" args={['#202025', 0, 80]} />
      <Suspense fallback={null}>
        <group rotation={[10, 10.5, 10]}>
          <Cloud count={7} radius={20} />
        </group>
      </Suspense>
      <TrackballControls />
    </Canvas>
  )
}
